// extracted by mini-css-extract-plugin
export default {"descriptionTab":"DescriptionTab_descriptionTab__ELYaK","descriptionImg":"DescriptionTab_descriptionImg__ArYyM","description":"DescriptionTab_description__AU9q7"};